import { useContext } from 'react'

import { FrameBuilderSelectionContext } from '../../contexts/selection-context'
import { FrameBuilderStringsContext } from '../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import ConfigurationStepPreview, {
  type StepPreviewProps,
} from './configuration-step-preview'

const PassepartoutStepPreview = ({ number, onClick }: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation, validationMessages } = useContext(
    FrameBuilderValidationContext,
  )

  return (
    <ConfigurationStepPreview
      step="passepartout"
      title={frameBuilderStrings.passepartoutStepTitle}
      value={committedStateSelectionMessages?.passepartout}
      error={
        validationMessages?.passepartoutSizePreview ||
        validationMessages?.passepartoutColorPreview
      }
      placeholder={frameBuilderStrings.passepartoutPlaceholder}
      opacity={stepPreviewAnimation.passepartoutOpacity}
      number={number}
      onClick={onClick}
      className="grow-0 shrink-0"
    />
  )
}

export default PassepartoutStepPreview
